
import Vue from 'vue';

Vue.component('move-bookmark-vue', {

  mounted() {
    const listItems = document.querySelectorAll('.dropdown-list li');

    // Set the initial selected state and append SVG
    listItems[0].classList.add('selected');
    appendSvgToSelected();

    // Add click event listeners to update selected state
    listItems.forEach(addListItemClickListener);

    function addListItemClickListener(item) {
      item.addEventListener('click', function() {
        updateSelectedState(item);
      });
    }

    function updateSelectedState(selectedItem) {
      listItems.forEach(li => li.classList.remove('selected'));
      selectedItem.classList.add('selected');
      appendSvgToSelected();
      replaceTriggerSpan(selectedItem);
    }

    function appendSvgToSelected() {
      const selectedLi = document.querySelector('.selected');
      const spanElement = selectedLi ? selectedLi.querySelector('span') : null;

      // Remove existing SVG elements
      document.querySelectorAll('.dropdown-list svg').forEach(svg => svg.remove());

      if (spanElement) {
        const svgElement = createSvgElement();
        spanElement.parentNode.insertBefore(svgElement, spanElement.nextSibling);
      }
    }

    function createSvgElement() {
      const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svgElement.setAttribute("width", "18");
      svgElement.setAttribute("height", "14");
      svgElement.setAttribute("viewBox", "0 0 18 14");

      const pathElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
      pathElement.setAttribute("d", "M6.4 13.529L.29 7.418l1.723-1.724 4.388 4.376L15.677.793l1.724 1.736");

      svgElement.appendChild(pathElement);
      return svgElement;
    }
    // Function to replace trigger button span
    function replaceTriggerSpan(selectedItem) {
      const triggerButtonSpan = document.querySelector(".dropdown-trigger span");
      const selectedItemSpan = selectedItem.querySelector('span');
      triggerButtonSpan.textContent = selectedItemSpan.textContent.trim();
    }
    //new move bookmark flow
    const mainWrapper = document.querySelector('.bookmark-folder-wrapper .bookmark-folder-btns');
    const createFolderButton = mainWrapper.querySelector('.btn_secondary');
    const backFolderButton = mainWrapper.querySelector('.back-btn');
    const moveButton = mainWrapper.querySelector('.bookmark-folder');
    const dropdownWrapper = document.querySelector('.bookmark-folder-select-folder');
    const inputTextBox = dropdownWrapper.querySelector('.folder-input-box');
    const dropdownTrigger = dropdownWrapper.querySelector('.dropdown');

    createFolderButton.addEventListener('click', () => toggleDropdown(true));
    backFolderButton.addEventListener('click', () => toggleDropdown(false));

    function toggleDropdown(showInput) {
      inputTextBox.style.display = showInput ? 'block' : 'none';
      moveButton.classList.toggle('btn-disable', showInput && !inputTextBox.value.trim());
      createFolderButton.style.display = showInput ? 'none' : 'flex';
      backFolderButton.style.display = showInput ? 'flex' : 'none';
      dropdownTrigger.style.display = showInput ? 'none' : 'block';

      if (!showInput) {
        inputTextBox.value = '';
        moveButton.classList.remove('btn-disable');
      }
    }

    inputTextBox.addEventListener('input', () => {
      moveButton.classList.toggle('btn-disable', !inputTextBox.value.trim());
    });

    // Add event listener to the back button
    backFolderButton.addEventListener("click", function() {
      listItems.forEach(li => li.classList.remove('selected'));
      listItems[0].classList.add('selected');
      appendSvgToSelected();
      replaceTriggerSpan(listItems[0]);
    });
     //input focus logic
     inputTextBox.addEventListener('input', function() {
      this.classList.add('typing');
    });

    inputTextBox.addEventListener('blur', function() {
      if (this.value.trim() === '') {
        this.classList.remove('typing');
      }
    });
  }
});
